import { useEffect, useState } from "react";
import axios from "axios";
import { withRouter } from "react-router-dom";
import qs from "querystring-es3";
import { setToken } from "../../utils/getToken";
import service from "../../utils/service";

const Auth = ({ location, history }) => {
  const [status, setStatus] = useState("loading");
  const [cognitoConfig, setCognitoConfig] = useState(null);
  useEffect(() => {
    fetchAuthConfig();
  }, []);

  useEffect(() => {
    if (!cognitoConfig) return;
    const params = new URLSearchParams(location.search);
    const code = params.get("code");

    if (!code) {
      setStatus("error");
      return;
    }
    exchangeToken(code);
  }, [cognitoConfig, location.search]);


  const fetchAuthConfig = async () => {
    try {
      const response = await service.get("v4/configs/auth");
      const cognito = response?.data?.auth?.cognito;
      if (!cognito?.enabled) {
        setStatus("error");
        return;
      }

      setCognitoConfig(cognito);
    } catch (err) {
      console.error("Failed to fetch auth config", err);
      setStatus("error");
    }
  };

  const exchangeToken = async (code) => {
    try {
      const REDIRECT_URI = `${window.location.origin}/users/auth/cognito_idp/callback`;
      const body = {
        grant_type: "authorization_code",
        client_id: cognitoConfig.client_id,
        code,
        redirect_uri: REDIRECT_URI,
      };
       const basicAuth = btoa(`${cognitoConfig?.client_id}:${cognitoConfig?.secret_key}`);
      const response = await axios.post(
        `${cognitoConfig.user_pool_site}/oauth2/token`,
        qs.stringify(body),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Basic ${basicAuth}`,
          },
        }
      );

      const { id_token, access_token } = response.data;
      if (!id_token) throw new Error("No id_token received");
      const responseData = await service.post(
        "v4/users/cognito_login",
        {
          id_token,
          access_token,
        }
      );
      const TOKEN = responseData?.data?.token;
      if (!TOKEN) throw new Error("Backend token missing");
      localStorage.setItem("CW_JWT_TOKEN", TOKEN);
      setToken(TOKEN);
      history.replace("/");
    } catch (error) {
      console.error("Cognito login failed:", error);
      setStatus("error");
    }
  };

  return (
    <>
      {status === "loading" && <div>Logging you in...</div>}
      {status === "error" && (
        <div>Authentication failed. Please try again.</div>
      )}
    </>
  );
};

export default withRouter(Auth);